import styled from "styled-components";
import { Row, Col, Grid } from "antd";
import { useTrackVisibility } from "react-intersection-observer-hook";

import { RAImage } from "@/components/customs";
import { IconFillBestRateSvg, IconFillPrioritizedSvg, IconFillTailorBenefitsSvg } from "@/assets/images";
import { RAButtonPrimary, RATypography } from "@/components/customs";
import { PATH_PUBLIC_IMAGES } from "@/config/images";
import { PATH_ROUTES } from "@/config/routes";
import { useEffect, useState } from "react";
import { HeaderSection } from "../../Cards";

const { useBreakpoint } = Grid;

export function PrivateJetTravelCardProgram({ jet_card_program = {} }) {
	const [ref, { isVisible }] = useTrackVisibility();
	const [visible, setVisible] = useState(false);

	useEffect(() => {
		if (isVisible) {
			setVisible(true);
		}
	}, [isVisible]);

	return (
		<div ref={ref} style={{ opacity: visible ? 1 : 0 }}>
			<CardContent
				className={`${visible && "animate__animated animate__fadeInUp"}`}
				style={{ animationDuration: "1.5s" }}
			>
				<CardContentHeader>
					<WrapperContent className={`${visible && "animate__animated animate__fadeInUp"}`}>
						<HeaderSection
							title={jet_card_program?.title || ""}
							description={jet_card_program?.description || ""}
						/>
					</WrapperContent>
					<RATypography variant="sub-heading4" bottom={30}>
						{jet_card_program?.tagline || ""}
					</RATypography>
					<RAButtonPrimary
						type="link"
						href={PATH_ROUTES.PATH_CONTACT_US}
						title={jet_card_program?.button_content || ""}
						size="middle"
						background="transparent"
					/>
				</CardContentHeader>
				<JetCardImageWrapper>
					<JetCardImage>
						<RAImage
							url={jet_card_program?.photo || PATH_PUBLIC_IMAGES.private_jet_travel_5}
							width="100%"
							height="100%"
							objectFit="contain"
						/>
					</JetCardImage>
				</JetCardImageWrapper>
			</CardContent>
			<WrapperSection>
				<Row gutter={[1, 1]}>
					<Col lg={8} xs={24} className={`${visible && "animate__animated animate__zoomIn"} card-program`}>
						<CardSectionItem
							cardIndex={0}
							name={jet_card_program?.hight_light1?.title || ""}
							description={jet_card_program?.hight_light1?.description || ""}
							icon={<RAImage url={IconFillPrioritizedSvg} width={32} height={32} />}
						/>
					</Col>
					<Col lg={8} xs={24} className={`${visible && "animate__animated animate__zoomIn"} card-program`}>
						<CardSectionItem
							cardIndex={1}
							name={jet_card_program?.hight_light2?.title || ""}
							description={jet_card_program?.hight_light2?.description || ""}
							icon={<RAImage url={IconFillBestRateSvg} width={32} height={32} />}
						/>
					</Col>
					<Col lg={8} xs={24} className={`${visible && "animate__animated animate__zoomIn"} card-program`}>
						<CardSectionItem
							cardIndex={2}
							name={jet_card_program?.hight_light3?.title || ""}
							description={jet_card_program?.hight_light3?.description || ""}
							icon={<RAImage url={IconFillTailorBenefitsSvg} width={32} height={32} />}
						/>
					</Col>
				</Row>
			</WrapperSection>
		</div>
	);
}

const CardSectionItem = ({ name = "", description = "", icon, cardIndex }) => {
	const { lg } = useBreakpoint();

	return (
		<WrapperItem
			style={
				cardIndex === 1
					? lg
						? { borderLeft: "1px solid #e9e8e8", borderRight: "1px solid #e9e8e8" }
						: { borderTop: "1px solid #e9e8e8", borderBottom: "1px solid #e9e8e8" }
					: {}
			}
		>
			{icon}
			<div style={{ marginTop: 16 }}>
				<RATypography variant="sub-heading3">{name}</RATypography>
				<RATypography variant="body3" color="#595959" top={6}>
					{description}
				</RATypography>
			</div>
		</WrapperItem>
	);
};

const WrapperItem = styled.div`
	padding: 24px;
	height: 100%;
`;

const WrapperSection = styled.div`
	margin-top: 30px;
	border: 1px solid #e9e8e8;
	padding: 1px;
	border-radius: 8px;
	overflow: hidden;
	background: linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, #fff 100%);
`;

const WrapperContent = styled.div`
	margin-bottom: 12px;
`;

const CardContent = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 80px;

	@media (max-width: 1199px) {
		gap: 40px;
	}

	@media (max-width: 991px) {
		flex-direction: column;
	}
`;

const CardContentHeader = styled.div`
	width: 100%;
`;

const JetCardImageWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;

	@media (max-width: 991px) {
		width: 100%;
		height: 100%;
	}
`;

const JetCardImage = styled.div`
	position: relative;
	width: 450px;
	height: 300px;

	@media (max-width: 1199px) {
		width: 350px;
		height: 240px;
	}

	@media (max-width: 991px) {
		width: 100%;
		height: 300px;
	}

	@media (max-width: 575px) {
		height: 240px;
	}
`;
